<template>
  <div class="invoice-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-confirm @confirm="showMakeInvoiceDialog" value="开票" v-if="permissionCodes.indexOf('016004001') !== -1"/>
        <button-cancel @cancel="syncInvoiceSelection" value="批量同步发票状态" style="margin-left: 10px;" v-if="permissionCodes.indexOf('016004002') !== -1"/>
        <!--<button-confirm-next value="经纪人申请" @confirm="showWindowLeftBox" style="margin-left: 10px;"/>-->
        <button-export :href="exportUrl" :beforeDownload="beforeDownload" download="download.xls" value="导出"/>
        <button-confirm @confirm="showConfig" value="小程序开票配置" v-if="permissionCodes.indexOf('016004005') !== -1"/>
      </div>
      <input-search placeholder="发票号/发票抬头" @search="searchKey" />
    </div>
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          style="width: 1.8rem"
          v-model="timeValue"
          type="daterange"
          :picker-options="pickerOptions2"
          size="small"
          unlink-panels
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeTimeValue" >
        </el-date-picker>
      </div>
      <div class="btn-box">
        <input-select selectTitle="开票类型" selectKey="invoiceType" :selectData="invoiceTypeList" @search="search" style="margin-right: 10px;"/>
        <input-select selectTitle="发票类型" selectKey="receiptType" :selectData="receiptTypeList" @search="search" style="margin-right: 10px;"/>
        <input-select selectTitle="审批状态" selectKey="approvalStatus" :selectData="approvalStatusList" @search="search" style="margin-right: 10px;"/>
        <input-select selectTitle="发票状态" selectKey="invoiceStatus" :selectData="invoiceStatusList" @search="search" style="margin-right: 10px;"/>
      </div>
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @lookOver="lookOver" @changePagination="changePagination" @changeSelection="changeSelection" :operationArr="operationArr" @invoiceDetailRow="toInvoiceRecordInfoPage" @invalidInvoiceRow="invalidInvoice" @synchronousRow="synchronousRow" @hongChongInvoiceRow="hongChongInvoice" @ordinaryInvoiceRow="ordinaryInvoiceRow" @reopenInvoiceRow="reopenInvoice" tableOperationWidth="240" />

    <el-dialog title="关联账单" :visible.sync="billVisible" width="60%">
      <table-main style="margin-top: 0.12rem" :selection="false" :tableHead="billTableHead" :tableData="billTableData" :pagination="false" :hasOperation="false" />
    </el-dialog>

    <el-dialog title='开票信息' :visible.sync="makeInvoiceDialogVisible" width="1200px">
      <form class="scroll-form-sty">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开票对象：</span>
          </div>
          <el-select
            v-model="payerCode"
            filterable
            remote
            :remote-method="getMainBodyList"
            placeholder="请输入关键词查询"
            size="mini"
            style="width: 630px">
            <el-option v-for="(item, i) in payerList" :key="item._value + i" :label="item.payer" :value="item._value"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">关联账单：</span>
          </div>
          <el-select v-model="payItemDetailListChoose" multiple collapse-tags placeholder="请选择" size="small" style="width: 630px">
            <el-option v-for="item in payItemDetailList" :key="item.billNo" :label="item._label" :value="item.billNo"></el-option>
          </el-select>
        </div>
        <div class="form-line" v-if="makeInvoiceData.length > 0">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开票项：</span>
          </div>
          <div style="display: flex;justify-content: flex-start;flex-direction: column;">
            <div v-for="item in makeInvoiceData" style="margin-bottom: 10px;">
              <el-descriptions direction="horizontal" :column="5" border size="mini">
                <el-descriptions-item label="名称">
                  <el-input v-model="item.goodsName" size="small" style="width: 120px" disabled />
                </el-descriptions-item>
                <el-descriptions-item label="税率">
                  <el-input v-model="item.taxrate" size="small" style="width: 90px"/>
                </el-descriptions-item>
                <el-descriptions-item label="金额">
                  <el-input v-model="item.money" size="small" style="width: 90px" disabled />
                </el-descriptions-item>
                <el-descriptions-item label="数量">
                  <el-input-number v-model="item.num" controls-position="right" :style="{ width: !item.num ? 12 + 'ch' : typeof item.num == 'string' ? item.num.length + 12 + 'ch' : item.num.toString().length + 12 + 'ch' }" style="max-width: 133px" :min="1" @change="changeNumber(item)"></el-input-number>
                </el-descriptions-item>
                <el-descriptions-item label="单价">
                  <el-input v-model="item.unitPrice" size="small" style="width: 90px" disabled />
                </el-descriptions-item>
                <el-descriptions-item label="销方">
                  <el-select v-model="item.resellerId" @change="changeReseller" placeholder="请选择" size="small" style="width: 560px;">
                    <el-option v-for="items in resellerIdList" :key="items.resellerId" :label="items.resellerName" :value="items.resellerId"></el-option>
                  </el-select>
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </div>

        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">发票抬头：</span>
          </div>
          <el-select v-model="buyerTitleCode" filterable remote reserve-keyword placeholder="请输入关键词" size="small" style="width: 630px" :remote-method="getInvoiceTitleList">
            <el-option v-for="item in buyerTitleList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">邮箱：</span>
          </div>
          <el-input v-model="email" size="small" style="width: 630px" />
        </div>
        <!--        <div class="form-line">-->
        <!--          <div class="textBox">-->
        <!--            <b class="red">*</b>-->
        <!--            <span class="line-text">发票类型：</span>-->
        <!--          </div>-->
        <!--          <el-radio-group v-model="kptype" style="width: 280px">-->
        <!--            <el-radio label="1">正票</el-radio>-->
        <!--            <el-radio label="2">红票</el-radio>-->
        <!--          </el-radio-group>-->
        <!--        </div>-->
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">发票类型：</span>
          </div>
          <el-radio-group v-model="invoiceLine" style="width: 630px">
            <el-radio label="p">普票</el-radio>
            <el-radio label="s">专票</el-radio>
            <el-radio label="pc">数电普票</el-radio>
            <el-radio label="bs">数电专票</el-radio>
          </el-radio-group>
        </div>
        <div class="form-line">
          <div class="textBox">
            <!--            <b class="red">*</b>-->
            <span class="line-text">备注类型：</span>
          </div>
          <el-select v-model="ordinaryMessageRadio" size="mini" @change="changeRemarkType" style="width: 630px">
            <el-option v-for="(item,index) in ordinaryMessageRadioList" :key="index" :label="item.name" :value="item.code"></el-option>
          </el-select>
          <el-checkbox v-model="remarkDefault">设为默认</el-checkbox>
        </div>
        <div v-show="isRealEstate" class="form-line">
          <div class="textBox">
            <span class="line-text">房产证号：</span>
          </div>
          <el-input v-model="realPropertyCertificate" size="small" style="width: 630px" />
        </div>
        <div class="form-line" style="margin-bottom: 0">
          <div class="textBox">
            <span class="line-text">备注：</span>
          </div>
          <el-input v-model="message" size="small" style="width: 630px" />
        </div>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="openInvoice">开 票</el-button>
        <el-button size="small" @click="makeInvoiceDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>


    <el-dialog title='重新开票' :visible.sync="ordinaryInvoiceDialogVisible" width="1200px">
      <form  class="scroll-form-sty">
        <!--        <div class="form-line">-->
        <!--          <div class="textBox">-->
        <!--            <span class="line-text">含税金额：</span>-->
        <!--          </div>-->
        <!--          <el-input v-model="ordinaryInvoiceMoney" size="small" style="width: 630px" disabled>-->
        <!--            <template slot="append">元</template>-->
        <!--          </el-input>-->
        <!--        </div>-->
        <div class="form-line" v-if="makeInvoiceData2.length > 0">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">开票项：</span>
          </div>
          <div style="display: flex;justify-content: flex-start;flex-direction: column;">
            <div v-for="item in makeInvoiceData2" style="margin-bottom: 10px;">
              <el-descriptions direction="horizontal" :column="5" border size="mini">
                <el-descriptions-item label="名称">
                  <el-input v-model="item.goodsName" size="small" style="width: 90px" disabled />
                </el-descriptions-item>
                <el-descriptions-item label="税率">
                  <el-input v-model="item.taxrate" size="small" style="width: 90px"/>
                </el-descriptions-item>
                <el-descriptions-item label="金额">
                  <el-input v-model="item.money" size="small" style="width: 90px" disabled />
                </el-descriptions-item>
                <el-descriptions-item label="数量">
                  <el-input-number v-model="item.num" controls-position="right" :style="{ width: !item.num ? 12 + 'ch' : typeof item.num == 'string' ? item.num.length + 12 + 'ch' : item.num.toString().length + 12 + 'ch' }" style="max-width: 133px" :min="1" @change="changeNumber(item)"></el-input-number>
                </el-descriptions-item>
                <el-descriptions-item label="单价">
                  <el-input v-model="item.unitPrice" size="small" style="width: 90px" disabled />
                </el-descriptions-item>
                <el-descriptions-item label="销方">
                  <el-select v-model="item.resellerId" placeholder="请选择" size="small" style="width: 560px;" disabled>
                    <el-option v-for="item in resellerIdList" :key="item.resellerId" :label="item.resellerName" :value="item.resellerId"></el-option>
                  </el-select>
                </el-descriptions-item>
              </el-descriptions>
            </div>
          </div>

        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">发票抬头：</span>
          </div>
          <el-select v-model="ordinaryBuyerTitleCode" filterable remote reserve-keyword placeholder="请输入关键词" size="small" style="width: 630px" :remote-method="getInvoiceTitleList">
            <el-option v-for="item in buyerTitleList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </div>
        <div class="form-line">
          <div class="textBox">
            <span class="line-text">邮箱：</span>
          </div>
          <el-input v-model="ordinaryEmail" size="small" style="width: 630px" disabled/>
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">发票类型：</span>
          </div>
          <el-radio-group v-model="ordinaryInvoiceLine" style="width: 630px">
            <el-radio label="p">普票</el-radio>
            <el-radio label="s">专票</el-radio>
            <el-radio label="pc">数电普票</el-radio>
            <el-radio label="bs">数电专票</el-radio>
          </el-radio-group>
        </div>
        <!--        <div class="form-line">-->
        <!--          <div class="textBox">-->
        <!--            &lt;!&ndash;            <b class="red">*</b>&ndash;&gt;-->
        <!--            <span class="line-text">备注类型：</span>-->
        <!--          </div>-->
        <!--          <el-select v-model="ordinaryMessageRadio" size="mini" @change="changeRemarkType" style="width: 630px">-->
        <!--            <el-option v-for="(item,index) in ordinaryMessageRadioList" :key="index" :label="item.name" :value="item.code"></el-option>-->
        <!--          </el-select>-->
        <!--          <el-checkbox v-model="remarkDefault">设为默认</el-checkbox>-->
        <!--        </div>-->
        <div class="form-line" v-show="isRealEstate">
          <div class="textBox">
            <span class="line-text">房产证号：</span>
          </div>
          <el-input v-model="realPropertyCertificate" size="small" style="width: 630px" />
        </div>
        <div class="form-line" style="margin-bottom: 0">
          <div class="textBox">
            <span class="line-text">备注：</span>
          </div>
          <el-input v-model="ordinaryMessage" size="small" style="width: 630px" />
        </div>
      </form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="confirmReopenInvoice">开 票</el-button>
        <el-button size="small" @click="ordinaryInvoiceDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="小程序开票配置"
      :visible.sync="changeNameVisible"
      top="0"
      class="contractDialogForm">
      <form style="width: unset">
        <div class="form-line">
          <div class="textBox" style="width: 0.5rem;margin-right: 0.05rem">
            <b class="red">*</b>
            <span class="line-text" style="margin-right: 0">发票类型:</span>
          </div>
          <el-select v-model="typeCodeList" style="width: 1.8rem;margin-right: 0" placeholder="请选择" filterable size="small" multiple ref='select'>
            <el-option
              v-for="item in typeList"
              :key="item.key"
              :label="item.label"
              :value="item.key">
            </el-option>
          </el-select>
        </div>
      </form>
      <div slot="footer" class="dialog-footer quick-dialog" style="margin-top: 0;margin-left: 0.625rem;padding-bottom: 0">
        <el-button
          size="mini"
          type="primary"
          @click="confirmChangeName"
        >确 定</el-button>
        <el-button @click="changeNameVisible = false" size="small">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
import InputSearch from '../../../components/Input/InputSearch'
import TableMain from '../../../components/Table/TableMain'
import {api} from '../../api/invoice'
import {errorHandler} from '../../../utils/errorHandler'
import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
import {nAlert, nError, nSuccess} from '../../../utils/notice'
import ButtonCancel from '../../../components/Button/ButtonCancel'
import ButtonAdd from "../../../components/Button/ButtonAdd";
import bus from "../../../utils/bus";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import InputSelect from "../../../components/Input/InputSelect";
import ButtonExport from "../../../components/Button/ButtonExport";

export default {
  components: {
    ButtonExport,
    InputSelect,
    ButtonConfirm,
    ButtonAdd,
    ButtonCancel,
    ButtonConfirmNext,
    TableMain,
    InputSearch,
    Breadcrumb},
  name: 'agent-manage',
  data () {
    return {
      permissionCodes: '',
      breadcrumb: [
        {value: '智慧凭证', name: 'invoice-over-view'},
        {value: '发票管理'}
      ],
      pickerOptions2: {
        disabledDate (time) {
          return time.getTime() > new Date(((new Date) / 1000 + 86400) * 1000)
        },
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      tableHead: [
        {prop: 'receiptNo', label: '发票号',},
        {prop: 'receiptTitle', label: '发票抬头',},
        {prop: 'invoiceTypeText', label: '开票类型'},
        {prop: 'receiptType', label: '发票类型'},
        {prop: 'taxIncludedAmount', label: '含税金额(元)',},
        {prop: 'taxFreeAmount', label: '不含税金额(元)',},
        {isLooking: true, label: '关联账单'},
        {prop: 'personName', label: '申请人'},
        {prop: 'createTime', label: '申请时间'},
        {prop: 'approvalStatusText', label: '审批状态'},
        {prop: 'invoiceStatusText', label: '发票状态'},
        {prop: 'resultMsg', label: '开票说明'},
      ],
      tableData: [],
      operationArr: ['invoiceDetail', 'synchronous', 'hongChongInvoice', 'ordinaryInvoice', 'invalidInvoice', 'allowReopen'],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      currentYearMonth: '',
      timeValue: [],
      invoiceTypeList: [
        {key: '', label: '全部'},
        {key: '1', label: '正票'},
        {key: '2', label: '红票'}
      ],
      receiptTypeList: [
        {key: '', label: '全部'},
        {key: '增值税专用发票', label: '增值税专用发票'},
        {key: '电子增值税普通发票', label: '电子增值税普通发票'},
        {key: '数电普票', label: '数电普票'},
        {key: '数电专票', label: '数电专票'},
      ],
      dialogFormData: [],
      typeCodeList: [],
      typeList: [
        {key: 'p', label: '电子增值税普通发票'},
        {key: 'pc', label: '数电普票'},
        {key: 'bs', label: '数电专票'},
      ],
      changeNameVisible: false,
      invoiceStatusList: [
        {key: '', label: '全部'},
        {key: 'PENDING', label: '开票中'},
        {key: 'SUCCESS', label: '开票成功'},
        {key: 'FAIL', label: '开票失败'},
        {key: 'INVALID', label: '已作废'},
        {key: 'RED_APPLY_PENDING', label: '红冲申请中'},
        {key: 'FLUSHED_RED', label: '已红冲'}
      ],
      approvalStatusList: [
        {key: '', label: '全部'},
        {key: '1', label: '审批中'},
        {key: '2', label: '已驳回'},
        {key: '3', label: '已通过'},
        {key: '4', label: '已撤回'},
      ],
      requestData: {
        invoiceType: '',
        receiptType: '',
        invoiceStatus: '',
        pageNum: 1,
        pageSize: 10,
        startTime: '',
        endTime: '',
        searchKey: ''
      },


      selectionArr: [],

      payerList: [],
      payerCode: '',
      payer: '',
      enterpriseCode: '',
      personCode: '',

      payItemDetailList: [],
      payItemDetailListChoose: [],

      buyerTitleCode: '',
      buyerTitleList: [],
      email: '',
      kptype: '1',
      invoiceLine: 'p',
      isRealEstate: false,
      realPropertyCertificate: '',
      message: '',
      makeInvoiceData: [],
      makeInvoiceData2: [],
      makeInvoiceDialogVisible: false,
      ordinaryMessageRadio: '',
      ordinaryMessageRadioList: [
        // {label: '房间号/区间/面积', value: '1'},
        // {label: '合同联系地址', value: '2'},
        // {label: '物业位置/区间/面积', value: '4'},
        // {label: '位置/区间', value: '5'},
        // {label: '区间/地址', value: '6'},
        // {label: '租赁地址', value: '7'},
        // {label: '自定义', value: '3'},
      ],
      remarkDefault: false,

      ordinaryInvoiceDialogVisible: false,
      ordinaryInvoiceData: '',
      ordinaryInvoiceMoney: '',
      ordinaryBuyerTitleCode: '',
      ordinaryEmail: '',
      ordinaryInvoiceLine: '',
      ordinaryMessage: '',

      billVisible: false,
      billTableHead: [
        {prop: 'payer', label: '账单主体'},
        {prop: 'billType', label: '账单类型',},
        {prop: 'memo', label: '账单区间',},
        {prop: 'billAmount', label: '账单金额(元)',},
        {prop: 'payTime', label: '收款时间'}
      ],
      billTableData: [],

      exportUrl: '',
      resellerIdList: [],
      rentAddress:''
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
    this.getCreatTime()
    this.getInvoiceTitleList()
    this.getConfiguration();
  },
  activated() {
    this.getPage();
    this.getInvoiceRemarkList();
    this.getConfiguration();
  },
  methods: {
    // 提交模块名称
    confirmChangeName(){
      if (!this.typeCodeList || this.typeCodeList.length === 0) {
        return nError('请选择发票类型')
      }
      let arr = []
      this.typeCodeList.map(v =>{
        this.typeList.map(v2=>{
          if (v === v2.key) {
            let obj = {
              invoiceType: v,
              typeName: v2.label
            }
            arr.push(obj);
          }
        })
      })
      this.$axios.post(`${api.updateInvoiceTypeConfig}`, arr)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('配置成功')
            this.changeNameVisible = false;
          }
        })
        .catch(errorHandler('查询失败'))
    },

    getConfiguration () {
      this.$axios.get(`${api.getConfiguration}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data
            this.resellerIdList = list
          }
        })
        .catch(errorHandler('查询失败'))
    },

    getInvoiceTypeConfig () {
      this.$axios.get(`${api.getInvoiceTypeConfig}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let list = res.data.data;
            this.typeCodeList = [];
            if (list) {
              list.map(v =>{
                this.typeCodeList.push(v.invoiceType);
              })
            } else {
              this.typeCodeList = ['p'];
            }
            console.log(this.typeCodeList, 'this.typeCodeList')
            this.changeNameVisible = true;
          }
        })
        .catch(errorHandler('查询开票类型配置失败'))
    },
    changeNumber(item){
      item.unitPrice= item.money / item.num
      item.unitPrice=item.unitPrice.toFixed(2)
    },
    beforeDownload() {
      this.exportUrl = `${api.exportInvoiceRecord}?yq-app-code=${bus.global.yqCode}&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&invoiceType=${this.requestData.invoiceType}&receiptType=${this.requestData.receiptType}&invoiceStatus=${this.requestData.invoiceStatus}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`;
    },
    // 查询开票对象
    getMainBodyList (query) {
      this.$axios.post(api.getMainBodyList, {
        voucherType: '发票',
        // status: '1',
        invoiceStatus: '0',
        searchKey: query,
      })
        .then(res => {
          let data = res.data.data
          data.map(v => {
            if (v.enterpriseCode) {
              v._value = `${v.enterpriseCode}${v.payer}`
            } else {
              v._value = `${v.personCode}${v.payer}`
            }
          })
          this.payerList = data
          this.getConfiguration()
        })
        .catch(errorHandler('查询开票对象失败'))
    },

    // 根据开票对象查询账单
    getInvoiceListByMainBody () {
      let formData = {};
      formData.enterpriseCode = this.enterpriseCode;
      formData.personCode = this.personCode;
      if (!this.enterpriseCode && !this.personCode) {
        formData.payer = this.payer;
      }
      this.$axios.post(`${api.getInvoiceListByMainBody}`, formData)
        .then(res => {
          let data = res.data.data
          data.map(v => {
            if (v.memo) {
              v._label = `${v.paymentItemName}/${v.money}元/${v.memo}`
            } else {
              v._label = `${v.paymentItemName}/${v.money}元`
            }
          })
          this.payItemDetailList = data
        })
        .catch(errorHandler('查询账单失败'))
    },

    // 查询默认配置
    defaultRemark () {
      this.$axios.get(`${api.defaultRemark}`, {})
        .then(res => {
          let data = res.data.data
          if (data) {
            this.ordinaryMessageRadio = data
            this.remarkDefault = true
          }
        })
        .catch(errorHandler('查询默认配置失败'))
    },

    // 查询抬头
    getInvoiceTitleList (query) {
      this.$axios.post(api.getInvoiceTitleList, {
        searchKey: query
      })
        .then(res => {
          let list = res.data.data
          this.buyerTitleList = list
        })
        .catch(errorHandler('获取抬头失败'))
    },
    toInvoiceRecordInfoPage (serialNo) {
      this.$router.push({
        path: `/invoice_info_current/${serialNo}`
      })
    },
    getCreatTime () {
      let nowDate = new Date
      let year = nowDate.getFullYear()
      let month = (nowDate.getMonth() + 1) < 10 ? '0' + (nowDate.getMonth() + 1) : (nowDate.getMonth() + 1)
      let date = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
      // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.currentYearMonth = `${year}-${month}`
      this.timeValue[0] = year + '-' + month + '-01'
      this.timeValue[1] = year + '-' + month + '-' + date
      this.getPage()
    },
    changeTimeValue () {
      this.pageNum = 1
      this.pageSize = 10
      this.getPage()
    },
    getPage () {
      let reqData = this.requestData
      reqData.pageNum = this.pageNum
      reqData.pageSize = this.pageSize
      if (this.timeValue) {
        reqData.startTime = `${this.timeValue[0]} 00:00:00`
        reqData.endTime = `${this.timeValue[1]} 23:59:59`
      } else {
        reqData.startTime = ''
        reqData.endTime = ''
      }
      this.$axios.post(api.getInvoiceRecordPage, reqData)
        .then(res => {
          let list = res.data.data.list
          this.total = res.data.data.total
          list.map(v => {
            v.code = v.orderNo
            this.invoiceStatusList.map(invoiceStatus => {
              if (invoiceStatus.key === v.invoiceStatus) {
                v.invoiceStatusText = invoiceStatus.label
              }
            })
            switch (v.approvalStatus) {
              case "1":
                v.approvalStatusText = '审批中';
                break;
              case "2":
                v.approvalStatusText = '已驳回';
                break;
              case "3":
                v.approvalStatusText = '已通过';
                break;
              case "4":
                v.approvalStatusText = '已撤回';
                break;
              default:
                v.approvalStatusText = '';
                break;
            }
            if (v.invoiceType === '1') {
              v.invoiceTypeText = '正票'
            } else if (v.invoiceType === '2') {
              v.invoiceTypeText = '红票'
            }
            if (v.createTime) {
              v.createTime = v.createTime.slice(0, 19)
            }
            // 作废
            if (v.invoiceDate) {
              if (v.invoiceType === '1' && (v.invoiceStatus === 'SUCCESS' || v.invoiceStatus === 'RED_APPLY_FAIL') && v.receiptType === '增值税专用发票' && v.invoiceDate.indexOf(this.currentYearMonth) !== -1) {
                v.allowInvalid = 'allow'
              } else {
                v.allowInvalid = 'notAllow'
              }
            }

            // 普票红冲
            if (v.invoiceType === '1' && v.invoiceStatus === 'SUCCESS' && (v.receiptType === '电子增值税普通发票'||v.receiptType === '数电普票'||v.receiptType === '数电专票')) {
              v.allowOrdinary = 'allow'
            } else {
              v.allowOrdinary = 'notAllow'
            }
            // 专票红冲
            // if (v.invoiceType === '1' && (v.invoiceStatus === 'SUCCESS' || v.invoiceStatus === 'RED_APPLY_FAIL') && v.receiptType === '增值税专用发票') {
            //   v.allowHongchong = 'allow'
            // } else {
            //   v.allowHongchong = 'notAllow'
            // }
            // 重新开票
            if (v.invoiceType === '1' && v.invoiceStatus === 'FAIL') {
              v.allowReopen = 'allow'
            } else {
              v.allowReopen = 'notAllow'
            }
          })
          this.tableData = list
        })
        .catch(errorHandler('获取失败'))
    },
    searchKey (v) {
      this.pageNum = 1
      this.requestData.searchKey = v
      this.getPage()
    },
    changePagination (data) {
      this.pageNum = data[0]
      this.pageSize = data[1]
      this.getPage()
    },
    search (v) {
      this.pageNum = 1
      this.requestData[v.key] = v.value
      this.getPage()
    },

    changeSelection (codeArr) {
      this.selectionArr = codeArr
    },
    // deleteSelection () {
    //   if (this.selectionArr.length === 0) {
    //     nAlert('请先选择需要删除的发票')
    //     return false
    //   } else {
    //     this.$confirm('是否确认删除所选中的发票？', '提示')
    //       .then(() => {
    //         this.deleteLine(this.selectionArr)
    //       })
    //       .catch(() => {
    //         console.log('取消删除')
    //       })
    //   }
    // },
    // deleteLine (code) {
    //   this.$axios.post(api.deleteAgent, code)
    //     .then(res => {
    //       if (res.data.retCode === 1) {
    //         nSuccess('删除成功')
    //         this.selectionArr = []
    //         this.getPage()
    //       }
    //     })
    //     .catch(errorHandler('删除失败'))
    // },

    // 查看关联账单
    lookOver (data) {
      this.$axios.get(`${api.getRelatedRecordList}/${data.orderNo}`, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.billVisible = true
            this.billTableData = data
          }
        })
        .catch(errorHandler('查询失败'))
    },

    // 普通发票红冲（后续改为专票红冲和普票红冲使用同一个按钮）
    ordinaryInvoiceRow (data) {
      this.$confirm('是否确定红冲发票', '提示', {
        type: 'warning'
      })
        .then(() => {
          let invoiceLine = '';
          switch (data.receiptType) {
            case "电子增值税普通发票":
              invoiceLine = 'p';
              break;
            case "数电普票":
              invoiceLine = 'pc';
              break;
            case "数电专票":
              invoiceLine = 'bs';
              break;
          }
          let reqData = {
            invoiceLine: invoiceLine,
            serialNo: data.serialNo,
            oriInvoiceCode: data.receiptCode,
            oriInvoiceNumber: data.receiptNo,
            sellerId: data.resellerId,
            buyerTaxNo: data.purchaserTaxpayerIdentificationNumber,
            buyerName: data.purchaserName
          }
          this.$axios.post(api.redInvoice, reqData)
            .then(res => {
              if (res.data.retCode === 1) {
                nSuccess('操作成功')
                this.selectionArr = []
                this.getPage()
              }
            })
            .catch(errorHandler('操作失败'))
        })
        .catch(() => {
          console.log('取消作废')
        })
    },

    // 申请红冲发票
    hongChongInvoice (data) {
      this.$confirm('是否确定申请红冲发票', '提示', {
        type: 'warning'
      })
        .then(() => {
          let reqData = {
            invoiceLine: 's',
            serialNo: data.serialNo,
            oriInvoiceCode: data.receiptCode,
            oriInvoiceNumber: data.receiptNo,
            sellerId: data.resellerId,
            buyerTaxNo: data.purchaserTaxpayerIdentificationNumber,
            buyerName: data.purchaserName
          }
          this.$axios.post(api.redInvoiceApply, reqData)
            .then(res => {
              if (res.data.retCode === 1) {
                nSuccess('操作成功')
                this.selectionArr = []
                this.getPage()
              }
            })
            .catch(errorHandler('操作失败'))
        })
        .catch(() => {
          console.log('取消作废')
        })
    },

    // 重新开票
    reopenInvoice (data) {
      console.log(data, 'dataaaaaaaa')
      this.ordinaryBuyerTitleCode = '';
      this.ordinaryEmail = '';
      this.buyerTitleList.map(v => {
        if (v.name === data.receiptTitle) {
          this.ordinaryBuyerTitleCode = v.code || ''
          this.ordinaryEmail = v.email || '';
        }
      })
      this.realPropertyCertificate = data.realPropertyCertificate || '';
      this.$axios.get(api.getInvoiceRecordItem+'/'+data.serialNo).then(res=>{
        this.makeInvoiceData2 = res.data.data
        console.log(this.makeInvoiceData2, 'this.makeInvoiceData2')
        let isRealEstate = false;
        this.makeInvoiceData2.map(v=>{
          v.unitPrice=(+v.unitPrice).toFixed(2)
          if (v.realPropertyFlag === '1') {
            isRealEstate = true;
          }
        })
        this.isRealEstate = isRealEstate;
      }).catch(errorHandler('获取开票项失败')).finally(()=>{
        this.makeInvoiceData2.map(v=>{
          v.resellerId = data.resellerId
        })
      })
      this.ordinaryInvoiceData = data
      this.ordinaryInvoiceLine = this.ordinaryInvoiceData.receiptType === '电子增值税普通发票' ? 'p' : 's'
      this.ordinaryMessage = this.ordinaryInvoiceData.receiptMemo === '--' ? '' : this.ordinaryInvoiceData.receiptMemo
      this.ordinaryInvoiceMoney = this.ordinaryInvoiceData.taxIncludedAmount === '--' ? '' : this.ordinaryInvoiceData.taxIncludedAmount;
      this.ordinaryInvoiceDialogVisible = true
    },

    // 重开发票
    confirmReopenInvoice () {
      // console.log(this.ordinaryInvoiceData, this.makeInvoiceData2, 'this.ordinaryInvoiceData')
      if (!this.ordinaryBuyerTitleCode) {
        nError('请选择发票抬头')
        return false
      }
      // const reg2 = /^(?!0$)\d+$/
      // if (this.realPropertyCertificate && !reg2.test(this.realPropertyCertificate)) {
      //   return nError('房产证号格式有误')
      // }
      this.makeInvoiceData2.map(item =>{
        this.resellerIdList.map(v =>{
          if (item.resellerId === v.resellerId) {
            item.resellerName = v.resellerName;
          }
        })
      })
      let reqData = {
        serialNo: this.ordinaryInvoiceData.serialNo,
        oriInvoiceCode: this.ordinaryInvoiceData.receiptCode === '--' ? '' : this.ordinaryInvoiceData.receiptCode,
        oriInvoiceNumber: this.ordinaryInvoiceData.receiptNo === '--' ? '' : this.ordinaryInvoiceData.receiptNo,
        sellerId: this.ordinaryInvoiceData.resellerId,
        titleCode: this.ordinaryBuyerTitleCode,
        invoiceLine: this.ordinaryInvoiceLine,
        memo: this.ordinaryMessage,
        consumptionDtos: this.makeInvoiceData2,
        realPropertyCertificate: this.realPropertyCertificate
      }
      this.$axios.post(api.reInvoicing, reqData)
        .then(res => {
          this.ordinaryInvoiceDialogVisible = false
          nSuccess('操作成功')
          this.getInvoiceTitleList()
          this.getPage()
        })
        .catch(errorHandler('操作失败'))
    },

    // 发票作废
    invalidInvoice (data) {
      this.$confirm('是否确定作废该发票', '提示', {
        type: 'warning'
      })
        .then(() => {
          let reqData = {
            fpqqlsh: data.serialNo,
            fpdm: data.receiptCode,
            fphm: data.receiptNo,
            resellerId: data.resellerId,
          }
          this.$axios.post(api.invalidInvoice, reqData)
            .then(res => {
              if (res.data.retCode === 1) {
                nSuccess('作废成功')
                this.selectionArr = []
                this.getPage()
              }
            })
            .catch(errorHandler('作废失败'))
        })
        .catch(() => {
          console.log('取消作废')
        })
    },

    syncInvoiceSelection () {
      if (this.selectionArr.length === 0) {
        nAlert('请先选择需要同步的发票')
        return false
      } else {
        this.$confirm('是否确认同步所选中的发票？', '提示')
          .then(() => {
            let selectionData = []
            this.tableData.map(v => {
              if (this.selectionArr.indexOf(v.orderNo) !== -1) {
                selectionData.push(v)
              }
            })
            this.synchronousRow(selectionData)
          })
          .catch(() => {
            console.log('取消同步')
          })
      }
    },

    synchronousRow (arr) {
      arr.map(v => {
        for (let i in v) {
          if (v[i] === '--') {
            v[i] = ''
          }
        }
      })
      this.$axios.post(api.syncInvoice, arr)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('同步成功')
            this.selectionArr = []
            this.getPage()
          }
        })
        .catch(errorHandler('同步失败'))
    },

    // 单开
    showMakeInvoiceDialog () {
      this.invoiceLine = 'p';
      this.ordinaryMessageRadio = '';
      this.makeInvoiceDialogVisible = true
      this.makeInvoiceData=[]
      this.getMainBodyList()
      this.getInvoiceTitleList()
    },

    showConfig() {
      this.getInvoiceTypeConfig();
    },

    openInvoice () {
      if (!this.payerCode) {
        nError('请选择开票对象');
        return;
      }
      if (this.payItemDetailListChoose.length === 0) {
        nError('请选择关联账单');
        return;
      }
      if (this.payItemDetailListChoose.length === 0) {
        nError('请选择关联账单');
        return;
      }
      if (this.makeInvoiceData.length === 0) {
        nError('开票项为空无法开票');
        return;
      }
      if (this.makeInvoiceData.length > 0) {
        let isMakeInvoice = true;
        this.makeInvoiceData.map(item =>{
          if (!item.taxrate || !item.num || !item.resellerId) {
            isMakeInvoice = false;
          }
          this.resellerIdList.map(v =>{
            if (item.resellerId === v.resellerId) {
              item.resellerName = v.resellerName;
            }
          })
        })
        if (!isMakeInvoice) {
          nError('开票项有误请检查');
          return;
        }
      }
      if (!this.buyerTitleCode) {
        nError('请选择发票抬头');
        return;
      }
      // const reg2 = /^(?!0$)\d+$/
      // if (this.realPropertyCertificate && !reg2.test(this.realPropertyCertificate)) {
      //   return nError('房产证号格式有误')
      // }
      let reqData = {
        buyerTitle: {},
        kptype: this.kptype,
        invoiceLine: this.invoiceLine,
        enterpriseName: '',
        enterpriseCode: this.enterpriseCode,
        personCode: this.personCode,
        personName: '',
        personPhone: '',
        message: this.message,
        consumptionDtos: this.makeInvoiceData,
        remarkType: this.ordinaryMessageRadio,
        remarkDefault: this.remarkDefault,
        realPropertyCertificate: this.realPropertyCertificate
      }
      if (this.enterpriseCode) {
        reqData.enterpriseName = this.payer
      } else if (this.personCode) {
        reqData.personName = this.payer
      }
      this.buyerTitleList.map(v => {
        if (v.code === this.buyerTitleCode) {
          reqData.buyerTitle = v
        }
      })
      // if (!this.ordinaryMessageRadio) {
      //   nError('备注类型不能为空');
      //   return;
      // }
      this.$axios.post(api.openInvoice, reqData)
        .then(res => {
          this.makeInvoiceDialogVisible = false
          this.payerCode = ''
          this.payer = ''
          this.payItemDetailList = []
          this.buyerTitleCode = ''
          this.buyerTitleList = []
          this.kptype = '1'
          this.invoiceLine = 'p'
          this.message = ''
          this.makeInvoiceData =[]
          nSuccess('操作成功')
          this.getPage()
        })
        .catch(errorHandler('操作失败'))
    },

    // 查询发票备注列表
    getInvoiceRemarkList() {
      this.$axios.post(api.getInvoiceRemarkList, {searchKey: ''})
        .then(res => {
          if (res.data.retCode === 1) {
            this.ordinaryMessageRadioList = res.data.data;
          }
        })
        .catch(errorHandler('同步失败'))
    },

    // 改变备注类型
    changeRemarkType() {
      let itemCode = [];
      if (this.payItemDetailList && this.payItemDetailList.length > 0) {
        itemCode = this.payItemDetailList.filter(item => {
          return item.billNo === this.payItemDetailListChoose[0];
        })
      }
      this.$axios.post(api.getInvoiceRemark, {code: this.ordinaryMessageRadio, billNo: this.payItemDetailListChoose[0] || '', paymentItemCode: itemCode[0].paymentItemCode || ''})
        .then(res => {
          if (res.data.retCode === 1) {
            this.message = res.data.data;
          }
        })
        .catch(errorHandler('查询备注信息失败'))
    },

    // 改变销方
    changeReseller() {
      // console.log(this.makeInvoiceData)
      let code = this.makeInvoiceData[0].paymentItemCode;
      let resellerArr = this.resellerIdList.filter(item=>{
        return item.resellerId === this.makeInvoiceData[0].resellerId
      })
      console.log(resellerArr, 'resellerArr')
      // let resellerId = this.makeInvoiceData[0].resellerId;
      this.$axios.get(`${api.getInvoiceTaxRateByCode}/${code}/${resellerArr[0].resellerId}`)
        .then(res => {
          if (res.data.retCode === 1) {
            this.makeInvoiceData[0].taxrate = res.data.data ? res.data.data.taxRate : '';
          }
        })
        .catch(errorHandler('获取税率信息失败'))
    },
  },
  watch: {
    timeValue (val) {
      this.getPage()
    },
    payerCode (val) {
      if (this.payerCode) {
        this.payerList.map(v => {
          if (v._value === val) {
            this.payer = v.payer
            this.enterpriseCode = v.enterpriseCode
            this.personCode = v.personCode
          }
        })
        this.getInvoiceListByMainBody()
      }
      this.payItemDetailListChoose = ''
      this.buyerTitleCode = ''
      this.payItemDetailList = []
      this.message = ''
    },
    buyerTitleCode (val) {
      if (this.buyerTitleCode) {
        this.buyerTitleList.map(v => {
          if (v.code === this.buyerTitleCode) {
            this.email = v.email || ''
          }
        })
      } else {
        this.email = ''
      }
    },
    ordinaryBuyerTitleCode (val) {
      if (this.ordinaryBuyerTitleCode) {
        this.buyerTitleList.map(v => {
          if (v.code === this.ordinaryBuyerTitleCode) {
            this.ordinaryEmail = v.email || ''
          }
        })
      } else {
        this.ordinaryEmail = ''
      }
    },
    makeInvoiceDialogVisible (val) {
      if (!this.makeInvoiceDialogVisible) {
        this.payerCode = ''
        this.payItemDetailListChoose = ''
        this.buyerTitleCode = ''
        this.payItemDetailList = []
        this.realPropertyCertificate = '';
        this.isRealEstate = false;
      }
    },
    ordinaryInvoiceDialogVisible (val) {
      if (!this.ordinaryInvoiceDialogVisible) {
        this.realPropertyCertificate = '';
        this.isRealEstate = false;
      }
    },
    payItemDetailListChoose (v) {
      let bills = [];
      let isRealEstate = false;
      console.log(this.payItemDetailListChoose, 'this.payItemDetailListChoose1')
      if (this.payItemDetailListChoose) {
        this.payItemDetailListChoose.map(v => {
          this.payItemDetailList.map(payItem => {
            if (payItem.billNo === v) {
              bills.push(payItem)
              if (payItem.realPropertyFlag === '1') {
                isRealEstate = true;
              }
            }
          })
        })
      }
      this.isRealEstate = isRealEstate;
      this.realPropertyCertificate = '';
      this.makeInvoiceData = bills;
      // console.log(this.makeInvoiceData, 'makeInvoiceData')
      if (this.ordinaryMessageRadio) {
        this.changeRemarkType();
      }
    },
  }
}
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.invoice-manage {
  .el-dialog .el-dialog__body .el-table .has-gutter th:first-child {
    /*width: 50%!important;*/
  }

  .right-slide-enter,
  .right-slide-leave-active {
    transform: translateX(100%);
  }

  .right-slide-leave-active,
  .right-slide-enter-active {
    transition: all 0.3s;
  }
  .window-left-box {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 60%;
    z-index: 10;
  }
  .window-left-box .move-enter-active, .window-left-box .move-leave-active {
    transition: all 2s linear;
    transform: translate3d(0, 0, 0);
  }
  .window-left-box .move-enter, .window-left-box .move-leave {
    transform: translate3d(100%, 0, 0);
  }
  .window-left-main {
    width: 100%;
    height: 100%;
    z-index: 30;
    background: #FFFFFF;
    padding: 5px 10px;
    overflow: auto;
  }

  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    opacity: .4;
    z-index: -1;
    background-color: #000000;
    transition: opacity .5s ease;
  }

  form {
    width: 1000px;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 25px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 100px;
    display: flex;
    justify-content: space-between;
  }
  .line-info {
    width: 220px;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
  }

  .person-management-drawer {
    .el-icon-back {
      margin: 20px 20px 10px;
      display: block;
      border: 0;
      font-size: 20px;
      background-color: #ffffff;
      cursor: pointer;
    }
    .el-icon-back:hover {
      color: #00a0e6;
    }
    .all-table-class .el-table td {
      padding: 10px 0;
    }
    form {
      position: relative;
      .drawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
      }
      .noDrawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
        height: 150px;
        line-height: 160px;
        border: 1px dashed #dcdfe6;
        text-align: center;
        color: #999999;
      }
    }
  }
  .drawerBtnBox {
    width: 360px;
    padding-right: 60px;
    margin: 40px auto 0;
    .btn-confirm {
      border: 0;
      color: #FFF;
      padding: 8px 16px;
      background-color: #00a0e6;
      border-radius: 4px;
      margin-right: 60px;
    }
    .btn-confirm:hover {
      color: #FFF;
      background-color: #06b3ff;
    }
    .reject-button {
      border: 0;
      background-color: #f25721;
      color: #FFFFFF;
      border-radius: 4px;
    }
    .reject-button:hover {
      background-color: #F96E3D;
    }
  }
}

.el-dialog__body {
  .el-table .cell{
    text-align: center;
  }
  .el-table th>.cell {
    color: #48576a;
    font-weight: bold;
  }
}
.el-dialog {
  .el-dialog .el-dialog__body .el-table__empty-block {
    margin: 0 auto;
  }
  .el-table__empty-text {
    width: auto;
  }
  .el-dialog__header {
    text-align: center
  }
  .el-dialog__body {
    .el-table th:first-child {
      width: auto!important;
    }
  }
}
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}
</style>
<style lang="less" scoped>
.quick-dialog {
  margin-top: 0;
}
/deep/.el-dialog__header {
  padding: 0.15rem 0.1rem 0;
}
/deep/.el-dialog__title {
  font-size: 0.12rem;
  color: #303133;
  font-weight: bold;
}
/deep/ .el-dialog {
  margin: 0!important;
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
}
/deep/ .el-dialog__body {
  padding: 0 0.1rem;
}
/deep/ .el-dialog__footer {
  padding: 0 0.1rem 0.1rem 0.1rem;
}
/deep/ .el-dialog__headerbtn {
  right: 0.1rem;
}
/deep/.contractDialogForm .el-dialog {
  width: unset;
}
/* 在大屏幕上增加字体大小 */
@media (min-width: 1930px) {
  //body {
  .el-button {
    padding: 7px 13px;
    font-size: 0.06rem;
  }
  /deep/.el-switch__core {
    border-radius: 60px;
  }
  //}
}
.scroll-form-sty {
  max-height: 500px;
  overflow-y: auto;
  width: 6rem;
  margin-bottom: 0.15625rem;
}
</style>



// WEBPACK FOOTER //
// src/view/Invoice/InvoiceManage/InvoiceManage.vue